class Config {
	static get(configKey) {
		try {
			let configData = JSON.parse(localStorage.getItem("config"));
			return configData ? configData[configKey] : undefined;
		} catch (e) {
			return undefined;
		}
	}
}

export default Config;